import React from 'react'; 
import PropTypes from 'prop-types';

const ServicesLink = ({lookup}) => {
    if (!lookup) return null;
    const gasRequest = lookup.gas.request.map((p) => (
        <li key={p.id}>
            <i className="fa fa-angle-double-right gasServices">
                <a href={p.link} className="link-widget"> {p.name}</a>
            </i>
        </li>));
    const electricRequest = lookup.electric.request.map((p) => (
        <li key={p.id}>
            <i className="fa fa-angle-double-right electricServices">
                <a href={p.link} className="link-widget"> {p.name}</a>
            </i>
        </li>));
    return (
        <nav className="servicesLink" id="myScrollspy1">
            <ul className="nav list-inline mainServices">
                <li>
                    <h4>{lookup.gas.title}</h4>
                    <ul className="nav list-inline services">
                        {gasRequest}
                    </ul>
                </li>
                <li>
                    <h4>{lookup.electric.title}</h4>
                    <ul className="nav list-inline services electricityServices">
                            {electricRequest}
                    </ul>
                </li>
            </ul>
        </nav>
    );
};

ServicesLink.propTypes = {
    lookup: PropTypes.object.isRequired
};

export default ServicesLink;